import React, { Fragment } from 'react'
import CardEmpty from "Utils/Cards/CardEmpty";
import { RenderNumber } from '../../../Utils/renderField/renderReadField';
import { getColorVariacionDRC } from '../../../Utils/LaboratorioDRC/Common';

/**
 * Componente para mostrar los datos de variación DRC.
 * @param {object} props - Props del componente.
 * @param {object} props.item - Objeto que contiene los datos de la finca.
 * @returns {JSX.Element} - Componente de datos de variación DRC.
 */
const DatosVariacionDRC = (props) => {
    const { item } = props;

    let configurado = false;
    const historial_variacion_drc = item.historial_variacion_drc ? item.historial_variacion_drc : [];

    let configVariacionDRC = {
        variacion_drc_solidos: 'NO CONFIGURADO',
        variacion_drc_latex: 'NO CONFIGURADO',
    }

    if (historial_variacion_drc.length > 0) {
        configurado = true;
        const configVigente = historial_variacion_drc[historial_variacion_drc.length - 1];
        configVariacionDRC = {
            variacion_drc_solidos: configVigente.variacion_drc_solidos,
            variacion_drc_latex: configVigente.variacion_drc_latex,
        }
    }

    return (
        <div className="mt-3">
            <CardEmpty noShadow>
                <label className="p-0 gris">DATOS DE VARIACIÓN DRC</label>
                <div className="formulario-fields-row mt-0">
                    <div className="formulario-field">
                        <label htmlFor="aplica_variacion_drc" className="m-0">¿APLICA VARIACIÓN DRC?</label>
                        <span >{item.aplica_variacion_drc ? "SÍ" : "NO"}</span>
                    </div>

                    <div className="formulario-field">
                        <label htmlFor="variacion_drc_solidos" className="m-0">VARIACIÓN DRC DE SÓLIDOS</label>
                        {configurado ?
                            <RenderNumber
                                value={configVariacionDRC.variacion_drc_solidos}
                                decimalScale={2}
                                suffix={" %"}
                                // prefix={configVariacionDRC.variacion_drc_solidos > 0 ? "+" : ""}
                                className={getColorVariacionDRC(configVariacionDRC.variacion_drc_solidos)}
                            />
                            :
                            <span>NO CONFIGURADO</span>
                        }
                    </div>

                    <div className="formulario-field">
                        <label htmlFor="variacion_drc_latex" className="m-0">VARIACIÓN DRC DE LÁTEX</label>
                        {configurado ?
                            <RenderNumber
                                value={configVariacionDRC.variacion_drc_latex}
                                decimalScale={2}
                                suffix={" %"}
                                // prefix={configVariacionDRC.variacion_drc_latex > 0 ? "+" : ""}
                                className={getColorVariacionDRC(configVariacionDRC.variacion_drc_latex)}
                            />
                            :
                            <span>NO CONFIGURADO</span>
                        }
                    </div>
                </div>
            </CardEmpty>
        </div>
    )
}

export default DatosVariacionDRC;
